import React from 'react';
import {
  capitalize,
  generateRandomKey,
  NaNtoNumber,
} from '../../../../assets/helpers/funciones';
import {
  MAX_PAYMENT_METHODS,
  paymentType,
  MAX_CASHBACK_METHODS,
  paymentChancesEnum,
} from '../../../../assets/helpers/options';
import { casheaMaxQuotas } from '../../../../assets/helpers/variables';
import moment from 'moment';

export const calculatePaid = (payments) => {
  let total = 0;
  for (let i = 0; i < payments?.length; i++) {
    total = total + NaNtoNumber(payments[i]?.amount);
  }
  if (total > 0) {
    return total.toFixed(2);
  } else return null;
};

export const PaymentChangesSection = (props) => {
  const { data, payment } = props;
  // dueIndex
  let payments = [];
  let filterPayments = [];

  // if (payment === paymentChancesEnum.DE_CONTADO) {
  //   filterPayments = data?.paymentChanges.filter(
  //     (p) => p.type === 'membership'
  //   );
  // }

  // if (payment === paymentChancesEnum.INICIAL) {
  //   filterPayments = data?.paymentChanges.filter((p) => p.dueIndex === 0);
  // }

  // if (payment === paymentChancesEnum.FIRST_QUOTA) {
  //   filterPayments = data?.paymentChanges.filter((p) => p.dueIndex === 1);
  // }

  for (let i = 0; i < MAX_CASHBACK_METHODS; i++) {
    payments?.push({
      amount: filterPayments[i]?.amount || '',
      amountBs: filterPayments[i]?.amountBs || '',
      method: filterPayments[i]?.method || '',
      ref: filterPayments[i]?.ref || '',
    });
  }

  return (
    <>
      <td>{calculatePaid(payments)}</td>
      {payments.map((p) => (
        <React.Fragment key={p?._id}>
          <td>{p?.amount}</td>
          <td>{p?.amountBs}</td>
          <td>{capitalize(p?.method)}</td>
          <td>{p?.ref}</td>
        </React.Fragment>
      ))}
    </>
  );
};

export const PaymentChangesSectionMem = (props) => {
  const { data } = props;
  // dueIndex
  let payments = [];
  for (let i = 0; i < MAX_CASHBACK_METHODS; i++) {
    payments?.push({
      amount: data[`paymentChangesMem${i + 1}Amount`] || '',
      amountBs: data[`paymentChangesMem${i + 1}AmountBs`] || '',
      method: data[`paymentChangesMem${i + 1}Method`] || '',
      ref: data[`paymentChangesMem${i + 1}Ref`] || '',
    });
  }

  return (
    <>
      <td>{calculatePaid(payments)}</td>
      {payments.map((p) => (
        <React.Fragment key={p?._id}>
          <td>{p?.amount}</td>
          <td>{p?.amountBs}</td>
          <td>{capitalize(p?.method)}</td>
          <td>{p?.ref}</td>
        </React.Fragment>
      ))}
    </>
  );
};

export const PaymentChangesSectionFirstQuota = (props) => {
  const { data } = props;
  // dueIndex
  let payments = [];
  for (let i = 0; i < MAX_CASHBACK_METHODS; i++) {
    payments?.push({
      amount: data[`paymentChangesDue-1Change${i + 1}Amount`] || 0,
      amountBs: data[`paymentChangesDue-1Change${i + 1}AmountBs`] || 0,
      method: data[`paymentChangesDue-1Change${i + 1}Method`] || '',
      ref: data[`paymentChangesDue-1Change${i + 1}Ref`] || '',
    });
  }

  return (
    <>
      <td>{calculatePaid(payments)}</td>
      {payments.map((p) => (
        <React.Fragment key={p?._id}>
          <td>{p?.amount > 0 ? p?.amount?.toFixed(2) : ''}</td>
          <td>{p?.amountBs > 0 ? p?.amountBs?.toFixed(2) : ''}</td>
          <td>{capitalize(p?.method)}</td>
          <td>{p?.ref}</td>
        </React.Fragment>
      ))}
    </>
  );
};

export const PaymentChangesSectionInitial = (props) => {
  const { data } = props;
  // dueIndex
  let payments = [];
  for (let i = 0; i < MAX_CASHBACK_METHODS; i++) {
    payments?.push({
      amount: data[`paymentChangesDue0Change${i + 1}Amount`] || 0,
      amountBs: data[`paymentChangesDue0Change${i + 1}AmountBs`] || 0,
      method: data[`paymentChangesDue0Change${i + 1}Method`] || '',
      ref: data[`paymentChangesDue0Change${i + 1}Ref`] || '',
    });
  }

  return (
    <>
      <td>{calculatePaid(payments)}</td>
      {payments.map((p) => (
        <React.Fragment key={p?._id}>
          <td>{p?.amount > 0 ? p?.amount?.toFixed(2) : ''}</td>
          <td>{p?.amountBs ? p?.amountBs?.toFixed(2) : ''}</td>
          <td>{capitalize(p?.method)}</td>
          <td>{p?.ref}</td>
        </React.Fragment>
      ))}
    </>
  );
};

export const DuepaymentsSection = (props) => {
  const { data, index: paymentQty } = props;
  return Array.from({ length: MAX_PAYMENT_METHODS || 0 }).map((_, index) => (
    <React.Fragment key={index}>
      <td>{data[`paymentDues0PaymentUsd${index + 1}`] || ''}</td>
      <td>{data[`paymentDues0PaymentBss${index + 1}`] || ''}</td>
      <td>{data[`paymentDues0PaymentMethod${index + 1}`] || ''}</td>
      <td>{data[`paymentDues0PaymentReference${index + 1}`] || ''}</td>
      <td>{data[`paymentDues0PaymentAccHolder${index + 1}`] || ''}</td>
    </React.Fragment>
  ));
};

export const DuepaymentsColumn = (props) => {
  const { payment } = props;

  return (
    <>
      <td>{payment?.totalAmount}</td>
      <td>
        {payment?.totalAmountInBsS ? payment?.totalAmountInBsS?.toFixed(2) : ''}
      </td>
      <td>{capitalize(payment?.method)}</td>
      <td>{payment?.reference}</td>
      <td>{payment?.accHolder}</td>
    </>
  );
};

export const FirstQuota = (props) => {
  const { payment } = props;
  let payments = [];

  for (let index = 0; index < MAX_PAYMENT_METHODS; index++) {
    payments?.push({
      totalAmount: payment[`paymentDues1PaymentUsd${index + 1}`] || '',
      totalAmountInBsS: payment[`paymentDues1PaymentBss${index + 1}`] || '',
      method: payment[`paymentDues1PaymentMethod${index + 1}`] || '',
      reference: payment[`paymentDues1PaymentReference${index + 1}`] || '',
      accHolder: payment[`paymentDues1PaymentAccHolder${index + 1}`] || '',
    });
  }
  return (
    <>
      {payments.map((p) => (
        <React.Fragment key={p?._id}>
          <td>{p?.totalAmount}</td>
          <td>{p?.totalAmountInBsS}</td>
          <td>{capitalize(p?.method)}</td>
          <td>{p?.reference}</td>
          <td>{p?.accHolder}</td>
        </React.Fragment>
      ))}
    </>
  );
};

export const PendingQuotas = (props) => {
  const { payment: data, index: paymentQty } = props;
  let payments = [];

  for (let index = 0; index < (paymentQty < 1 ? 6 : paymentQty); index++) {
    payments?.push({
      paymentDate: [paymentType?.CASHEA].includes(data?.paymentType)
        ? data[`casheaPayment${index + 1}CreatedAt`] || ''
        : '',
      totalAmount: [paymentType?.CASHEA].includes(data?.paymentType)
        ? data[`casheaPayment${index + 1}AmountUsd`] || ''
        : '',
      totalAmountInBsS: [paymentType?.CASHEA].includes(data?.paymentType)
        ? data[`casheaPayment${index + 1}AmountBs`] || ''
        : '',
      method: [paymentType?.CASHEA].includes(data?.paymentType)
        ? data[`casheaPayment${index + 1}Method`] || ''
        : '',
      reference: [paymentType?.CASHEA].includes(data?.paymentType)
        ? data[`casheaPayment${index + 1}Reference`] || ''
        : '',
      accHolder: [paymentType?.CASHEA].includes(data?.paymentType)
        ? data[`casheaPayment${index + 1}AccHolder`] || ''
        : '',
    });
  }

  return (
    <>
      {payments.map((p) => (
        <React.Fragment key={p?._id}>
          {/* <td>{p?.dueDate}</td> */}
          <td>{p?.totalAmount}</td>
          <td>{p?.totalAmountInBsS}</td>
          <td>{p?.paymentDate}</td>
          <td>{capitalize(p?.method)}</td>
          <td>{p?.reference}</td>
          <td>{p?.accHolder}</td>
        </React.Fragment>
      ))}
    </>
  );
};

export const Duepayments = (props) => {
  const { data, index } = props;

  let pagos = [];

  for (let i = 0; i < 2; i++) {
    pagos?.push({
      dueDate:
        data?.paymentDues[index]?.paymentDetails?.length > 0 &&
        data?.paymentDues[index]?.dueDate
          ? data?.paymentDues[index]?.dueDate
          : '',
      totalAmount:
        data?.paymentDues[index]?.paymentDetails?.length > 0 &&
        data?.paymentDues[index]?.paymentDetails[i]?.totalAmount
          ? data?.paymentDues[index]?.paymentDetails[i]?.totalAmount
          : '',
      totalAmountInBsS:
        data?.paymentDues[index]?.paymentDetails?.length > 0 &&
        data?.paymentDues[index]?.paymentDetails[i]?.totalAmountInBsS
          ? data?.paymentDues[index]?.paymentDetails[i]?.totalAmountInBsS
          : '',
      method:
        data?.paymentDues[index]?.paymentDetails?.length > 0 &&
        data?.paymentDues[index]?.paymentDetails[i]?.method
          ? data?.paymentDues[index]?.paymentDetails[i]?.method
          : '',
      reference:
        data?.paymentDues[index]?.paymentDetails?.length > 0 &&
        data?.paymentDues[index]?.paymentDetails[i]?.reference
          ? data?.paymentDues[index]?.paymentDetails[i]?.reference
          : '',
    });
  }

  return (
    <>
      {pagos?.map((p) => (
        <DuepaymentsColumn key={p?._id} payment={p} />
      ))}
    </>
  );
};

export const SalesTablePayment = ({ data }) => {
  return (
    <>
      {Array.from({ length: MAX_PAYMENT_METHODS || 0 }).map((_, index) => (
        <React.Fragment key={index}>
          <td>
            {![paymentType.FINANCIADO, paymentType.CASHEA].includes(
              data?.paymentType
            )
              ? data[`payment${index + 1}Method`]
              : ''}
          </td>
          <td>
            {![paymentType.FINANCIADO, paymentType.CASHEA].includes(
              data?.paymentType
            )
              ? data[`payment${index + 1}AmountUsd`]
              : ''}
          </td>
          <td>
            {![paymentType.FINANCIADO, paymentType.CASHEA].includes(
              data?.paymentType
            )
              ? data[`payment${index + 1}AmountBs`]
              : ''}
          </td>
          <td>
            {![paymentType.FINANCIADO, paymentType.CASHEA].includes(
              data?.paymentType
            )
              ? data[`payment${index + 1}Reference`]
              : ''}
          </td>
          <td>
            {![paymentType.FINANCIADO, paymentType.CASHEA].includes(
              data?.paymentType
            )
              ? data[`payment${index + 1}AccHolder`]
              : ''}
          </td>
          <td>
            {![paymentType.FINANCIADO, paymentType.CASHEA].includes(
              data?.paymentType
            )
              ? data[`payment${index + 1}CreatedAt`]
              : ''}
          </td>
        </React.Fragment>
      ))}
    </>
  );
};
